import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="w-full border-t border-white/5 py-8 px-4" data-id="element-47">
        <div className="max-w-2xl mx-auto flex flex-col items-center gap-4" data-id="element-48">
          <div className="flex items-center gap-6" data-id="element-49">
            <button onClick={() => setPrivacyOpen(true)} className="text-sm text-gray-500 hover:text-[#25F4EE] transition-colors underline underline-offset-2 decoration-gray-700 hover:decoration-[#25F4EE]" data-id="element-50">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-51">·</span>
            <button onClick={() => setTermsOpen(true)} className="text-sm text-gray-500 hover:text-[#25F4EE] transition-colors underline underline-offset-2 decoration-gray-700 hover:decoration-[#25F4EE]" data-id="element-52">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-gray-600 text-xs" data-id="element-53">
            © {new Date().getFullYear()} TikTok Shop Afiliados Sprint. Todos
            los derechos reservados.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-54">
        <p className="text-white font-semibold" data-id="element-55">
          Última actualización: febrero 2026
        </p>

        <p data-id="element-56">
          Tu privacidad es importante para nosotros. Esta política describe qué
          información recopilamos, cómo la usamos y tus derechos al respecto.
        </p>

        <h3 className="text-white font-semibold pt-2" data-id="element-57">
          1. Información que recopilamos
        </h3>
        <p data-id="element-58">
          Al realizar una compra, recopilamos tu nombre, dirección de correo
          electrónico y datos de pago necesarios para procesar la transacción.
          No almacenamos información de tarjetas de crédito directamente — esto
          lo maneja nuestro procesador de pagos de forma segura.
        </p>

        <h3 className="text-white font-semibold pt-2" data-id="element-59">
          2. Uso de la información
        </h3>
        <p data-id="element-60">Utilizamos tu información exclusivamente para:</p>
        <ul className="list-disc list-inside space-y-1 text-gray-400" data-id="element-61">
          <li data-id="element-62">Entregar el producto digital que compraste</li>
          <li data-id="element-63">Enviarte actualizaciones relacionadas con tu compra</li>
          <li data-id="element-64">Mejorar nuestros productos y servicios</li>
        </ul>

        <h3 className="text-white font-semibold pt-2" data-id="element-65">
          3. Compartir información
        </h3>
        <p data-id="element-66">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago o cuando
          la ley lo requiera.
        </p>

        <h3 className="text-white font-semibold pt-2" data-id="element-67">4. Cookies</h3>
        <p data-id="element-68">
          Utilizamos cookies básicas para mejorar tu experiencia de navegación y
          analizar el tráfico del sitio de forma anónima.
        </p>

        <h3 className="text-white font-semibold pt-2" data-id="element-69">5. Tus derechos</h3>
        <p data-id="element-70">
          Puedes solicitar acceso, corrección o eliminación de tus datos
          personales en cualquier momento enviándonos un mensaje.
        </p>

        <h3 className="text-white font-semibold pt-2" data-id="element-71">
          6. Cambios a esta política
        </h3>
        <p data-id="element-72">
          Nos reservamos el derecho de actualizar esta política. Cualquier
          cambio será publicado en esta página con la fecha de actualización
          correspondiente.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-73">
        <p className="text-white font-semibold" data-id="element-74">
          Última actualización: febrero 2026
        </p>

        <p data-id="element-75">
          Al comprar y acceder a "TikTok Shop Afiliados en 14 Días (US) —
          Starter Sprint en Español", aceptas los siguientes términos y
          condiciones.
        </p>

        <h3 className="text-white font-semibold pt-2" data-id="element-76">1. Producto digital</h3>
        <p data-id="element-77">
          Este es un producto digital (PDF + plantillas). Una vez completada la
          compra, recibirás acceso inmediato al material. Debido a la naturaleza
          digital del producto, todas las ventas son finales.
        </p>

        <h3 className="text-white font-semibold pt-2" data-id="element-78">2. Uso permitido</h3>
        <p data-id="element-79">El contenido es para uso personal únicamente. No está permitido:</p>
        <ul className="list-disc list-inside space-y-1 text-gray-400" data-id="element-80">
          <li data-id="element-81">Redistribuir, revender o compartir el material</li>
          <li data-id="element-82">Reproducir el contenido como propio</li>
          <li data-id="element-83">Usar el material para crear productos competidores</li>
        </ul>

        <h3 className="text-white font-semibold pt-2" data-id="element-84">3. Resultados</h3>
        <p data-id="element-85">
          No garantizamos resultados específicos de ingresos o ventas. Los
          resultados dependen del esfuerzo individual, la consistencia y
          múltiples factores externos. Los ejemplos mencionados son
          ilustrativos, no promesas.
        </p>

        <h3 className="text-white font-semibold pt-2" data-id="element-86">
          4. Propiedad intelectual
        </h3>
        <p data-id="element-87">
          Todo el contenido, incluyendo textos, frameworks, plantillas y
          diseños, es propiedad del creador y está protegido por leyes de
          propiedad intelectual.
        </p>

        <h3 className="text-white font-semibold pt-2" data-id="element-88">
          5. Política de reembolso
        </h3>
        <p data-id="element-89">
          Debido a la naturaleza digital e inmediata del producto, no ofrecemos
          reembolsos una vez que el material ha sido entregado. Si tienes
          problemas técnicos para acceder al contenido, estaremos encantados de
          ayudarte.
        </p>

        <h3 className="text-white font-semibold pt-2" data-id="element-90">6. Modificaciones</h3>
        <p data-id="element-91">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. El uso continuado del producto implica la aceptación de los
          términos actualizados.
        </p>
      </LegalModal>
    </>;
}